import {
  IMetadatum,
} from '../fetchedData/productMetadata';
import {
  IFilterOutput,
  INodeWithoutRCAStatus,
  ITextLayoutOutput,
  LayoutTextWithoutRCAStatus,
} from './Utils';

const filter = (
    deselectedCategories: number[],
    input: ITextLayoutOutput,
    metadata: Map<number, IMetadatum>,
  ): IFilterOutput => {

  const {nodes, texts, ...rest} = input;
  const set = new Set(deselectedCategories);
  const filteredNodes: INodeWithoutRCAStatus[] = nodes.map(node => ({
    ...node,
    isActive: !set.has(node.section),
    code: metadata.get(node.id)!.code,
  }));
  const filteredTexts: LayoutTextWithoutRCAStatus[] = texts.map(text => ({
    ...text,
    isActive: !set.has(text.section),
  }));
  const result: IFilterOutput = {
    ...rest,
    nodes: filteredNodes,
    texts: filteredTexts,
  };
  return result;

};

export default filter;
